import React, { memo, useEffect, useState } from 'react';
import clsx from 'clsx';
import Loading from '../Loading';
import SafeArea from '../SafeArea';
import './index.scss';

interface PageProps {
  loading?: boolean;
  dark?: boolean;
  className?: string;
  children?: any;
}

function Page(props: PageProps) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(props.loading || false);
  }, [props.loading]);

  return (
    <>
      {loading && <Loading />}
      <div
        className={clsx('pg', props.className, {
          dark: props.dark,
        })}
      >
        {props.children}
        <SafeArea position="bottom" />
      </div>
    </>
  );
}

export default memo(Page);
